import Paths from '@/routes/paths';
import useAuth from '@authentication/hooks/useAuth';
import React from 'react';
import { Navigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import { FullStack } from './private-route.styled';

interface Props {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<Props> = ({ children }) => {
  const { user, isLoading } = useAuth();

  if (isLoading)
    return (
      <FullStack alignItems={'center'} justifyContent={'center'}>
        <CircularProgress />
      </FullStack>
    );
  return user ? <>{children}</> : <Navigate to={Paths.LoginPage} />;
};

export default PrivateRoute;
